import RadioOptionList from '~/shared/components/RadioOptionList';
import { ExportSection } from './ExportModal';

export type ExportFormat = 'csv' | 'json';
export type FilterSelection = 'with_filters' | 'all_data';
export type DataRangeSelection = 'on_screen_data' | 'all_data';

export const FORMAT_OPTIONS = [
  {
    value: 'csv' as const,
    label: 'CSV',
    description: 'Comma-separated, compatible with Excel & Google Sheets',
  },
  {
    value: 'json' as const,
    label: 'JSON',
    description: 'Structured data, ideal for API integration & developers',
  },
];

export const FILTER_OPTIONS = [
  {
    value: 'with_filters' as const,
    label: 'With selected filters',
    description: 'Export only rows matching the current filter selection',
  },
  {
    value: 'all_data' as const,
    label: 'All data',
    description: 'Ignore filters and export the full dataset',
  },
];

interface ExportFormatSectionProps {
  groupName: string;
  value: ExportFormat;
  onChange: (v: ExportFormat) => void;
}

export function ExportFormatSection({ groupName, value, onChange }: ExportFormatSectionProps) {
  return (
    <ExportSection label="Format">
      <RadioOptionList
        name={groupName}
        options={FORMAT_OPTIONS}
        selected={value}
        onChange={onChange}
      />
    </ExportSection>
  );
}

interface ExportFilterSectionProps {
  groupName: string;
  value: FilterSelection;
  onChange: (v: FilterSelection) => void;
}

export function ExportFilterSection({ groupName, value, onChange }: ExportFilterSectionProps) {
  return (
    <ExportSection label="Applied filters">
      <RadioOptionList
        name={groupName}
        options={FILTER_OPTIONS}
        selected={value}
        onChange={onChange}
      />
    </ExportSection>
  );
}


interface ExportDataRangeSectionProps {
  groupName: string;
  value: DataRangeSelection;
  onChange: (v: DataRangeSelection) => void;
  onScreenLabel?: string;
  onScreenDescription?: string;
  allDataDescription?: string;
}

export function ExportDataRangeSection({
  groupName,
  value,
  onChange,
  onScreenLabel = 'On screen',
  onScreenDescription = 'Export only the rows currently visible on this page',
  allDataDescription = 'Export the full dataset',
}: ExportDataRangeSectionProps) {
  const options = [
    {
      value: 'on_screen_data' as const,
      label: onScreenLabel,
      description: onScreenDescription,
    },
    {
      value: 'all_data' as const,
      label: 'All data',
      description: allDataDescription,
    },
  ];

  return (
    <ExportSection label="Data range" borderBottom={false}>
      <RadioOptionList
        name={groupName}
        options={options}
        selected={value}
        onChange={onChange}
      />
    </ExportSection>
  );
}
